import { render, staticRenderFns } from "./electromagnetic_membrane.vue?vue&type=template&id=edb9857c&scoped=true"
import script from "./electromagnetic_membrane.vue?vue&type=script&lang=js"
export * from "./electromagnetic_membrane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb9857c",
  null
  
)

export default component.exports